
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import ExamList from "@/lib/model/exam/exam";
import gateway from "@/lib/request/gateway";
// import Candidate from "@/lib/model/exam/candidate";
import ExamListForm from "@/lib/form/exam/ExamListForm";
import axios, { CancelToken } from "axios";

@Component({
  components: {}
})
export default class MassUpload extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: Object, default: {} }) row!: ExamListForm;
  get visible() {
    return this.show;
  }
  get token() {
    return Auth.token;
  }
  active = 0;
  uploadUrl = "";
  uploadParams: any = {};
  errData = [];
  errAllData = [];
  pageNumber = 1;
  isUploading = false;
  isChecking = false;
  allSuccessFlag = false;
  writeSqling = false;
  isFinished = false;
  upLoadSource = axios.CancelToken.source();
  fileName = "";
  successNumber = 0;
  uploadId = "";
  timeInterval: any = null;
  writeSuccessNumber = 0;
  writeFailNumber = 0;
  // created() {}
  //
  // mounted() {}
  @Watch("visible", {
    immediate: true
  })
  visibleChange(value: boolean) {
    console.log(value, this.active, "valvlalvlalvla");
    if (!value && this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
  }
  close() {
    this.$emit("close");
  }
  downloadTemplate() {
    const dataUrl =
      process.env.VUE_APP_MASS_UPLOAD_HR +
      "/aiExam/exportExcel/2023/11/21/3df8666c5fc94b8f9f63c953fbc59a63/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5HR%E8%AF%84%E5%88%86%E6%A8%A1%E7%89%88.xlsx";
    const a = document.createElement("a");
    a.href = dataUrl;
    a.setAttribute("download", "批量添加候选人模板");
    a.click();
  }
  beforeUpload(file: File) {
    let isExcel = false;
    const jsLt1M = file.size / 1024 / 1024 < 1;
    const ext = file.name.toLowerCase().split(".");
    if (ext[ext.length - 1] == "xlsx") {
      isExcel = true;
    }
    if (!isExcel) {
      this.$message.error("上传文件只能是 xlsx 格式!");
      return;
    }
    if (!jsLt1M) {
      this.$message.error("上传文件大小不能超过1MB");
      return;
    }
    this.isUploading = true;
    this.fileName = file.name;
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        console.log(postRes, "postRespostRes");
        const tempUrl = postRes.cdn + "/" + postRes.dir;
        gateway // 上传
          .upload(postRes, file, { cancelToken: this.upLoadSource.token })
          .then((res: any) => {
            console.log("upload res : ", res);
            this.uploadParams.excelUrl = res.url;
            this.uploadParams.companyId = this.row.companyId;
            this.uploadParams.examId = this.row.examId;
            console.log(this.uploadParams);
            this.active += 1;
          })
          .then(() => {
            this.isUploading = false;
            this.isChecking = true;
            ExamList.mAuditParse(this.uploadParams) // 校验
              .then(res => {
                console.log(
                  res,
                  "candidateMCreateParseParamscandidateMCreateParseParamscandidateMCreateParseParams"
                );
                this.isChecking = false;
                const {
                  data: { successNumber, errorList }
                } = res;
                console.log(res);
                this.errAllData = [];
                if (errorList && errorList.length > 0) {
                  this.errData = errorList;
                  this.errAllData = errorList;
                  if (this.errAllData.length > 20) {
                    this.errData = this.errAllData.slice(0, 20);
                  } else {
                    this.errData = errorList;
                  }
                }
                if (this.errAllData.length === 0) {
                  this.allSuccessFlag = true;
                }
                this.successNumber = successNumber;
              })
              .catch(e => {
                this.isChecking = false;
                this.active = 0;
              });
          })
          .catch((err: any) => {
            return false;
          })
          .finally(() => {
            return false;
          });
      }
    });
  }
  uploadSuccess() {
    console.log("aaaa");
  }
  handleCurrentChange(pageNumber: number) {
    this.pageNumber = pageNumber;
    this.errData = this.errAllData.slice(
      0 + (this.pageNumber - 1) * 20,
      20 + (this.pageNumber - 1) * 20
    );
  }
  cancelUpload() {
    console.log("desTry");
    if (this.isUploading) {
      this.upLoadSource.cancel("操作取消");
      this.active = 0;
    }
  }
  reUpload() {
    this.active = 0;
    this.errData = [];
  }
  sureToUpload() {
    console.log(this.uploadParams);
    ExamList.mAuditSubmit(this.uploadParams).then(res => {
      const {
        data: { taskId }
      } = res;
      this.uploadId = taskId;
      this.active += 1;
      this.writeSqling = true;
      this.timeInterval = setInterval(() => {
        this.getResult();
      }, 60 * 1000);
      this.getResult();
      this.$emit("uploading", taskId);
    });
  }
  getResult() {
    ExamList.mAuditCheck({ taskId: this.uploadId }).then(res => {
      const { successNumber, totalNumber, failNumber } = res.data;
      if (successNumber + failNumber === totalNumber) {
        this.writeSqling = false;
        this.active += 1;
        this.isFinished = true;
        if (this.timeInterval) {
          clearInterval(this.timeInterval);
          this.timeInterval = null;
        }
        this.writeSuccessNumber = successNumber;
        this.writeFailNumber = failNumber;
        this.$emit("uploading", "");
        this.$forceUpdate();
      }
    });
  }
  reloadData() {
    this.active = 0;
    this.isUploading = false;
    this.isChecking = false;
    this.allSuccessFlag = false;
    this.writeSqling = false;
    this.isFinished = false;
    this.errData = [];
    this.errAllData = [];
  }
}
